var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 313 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 379",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2423"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2422"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5254",
    d: "M237.6 8.236a.6.6 0 0 0 .6-.6V.6a.6.6 0 1 0-1.2 0v7.039a.6.6 0 0 0 .6.597z",
    transform: "translate(-229.828 .1)",
    style: {
      fill: "#ff6161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5255",
    d: "M10.973 26.734a6.441 6.441 0 1 1-5.492-11.58.6.6 0 1 0-.4-1.125 7.634 7.634 0 1 0 6.51 13.725.6.6 0 0 0-.618-1.021z",
    transform: "translate(.1 -13.477)",
    style: {
      fill: "#ff6161"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5256",
    d: "M321.4 17.771a7.634 7.634 0 0 0-3.605-2.74.6.6 0 0 0-.41 1.121 6.412 6.412 0 0 1 3.14 9.611.6.6 0 1 0 .992.663 7.6 7.6 0 0 0-.118-8.655z",
    transform: "translate(-307.437 -14.447)",
    style: {
      fill: "#ff6161"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.eca11475c4c7c70ef1ae3f3b1322cf38.svg";
export { ForwardRef as ReactComponent };